import React from "react";

export const TERMINAL = ["completed", "cancelled", "rejected", "no_show", "lawyer_no_show"];

// One derived indicator for the room's realtime link: Connected / Reconnecting… / Ended.
export function sessionState(connected, terminal) {
  if (terminal) return { key: "ended", label: "Ended", dot: "bg-slate-400", text: "text-slate-500" };
  if (connected) return { key: "connected", label: "Connected", dot: "bg-emerald-500", text: "text-emerald-700" };
  return { key: "reconnecting", label: "Reconnecting…", dot: "bg-amber-500", text: "text-amber-700" };
}

export const fmtTime = (iso) => (iso ? new Date(iso).toLocaleString([], { dateStyle: "medium", timeStyle: "short" }) : "—");
export const fmtDuration = (a, b) => {
  if (!a || !b) return null;
  const mins = Math.max(0, Math.round((new Date(b) - new Date(a)) / 60000));
  return mins < 1 ? "under a minute" : `${mins} min`;
};
export const CANCEL_REASON = { discarded_by_user: "Booking discarded before payment", lawyer_rejected: "Declined by the lawyer", lawyer_no_show: "The lawyer did not join within the allowed waiting period" };

export const Lock = ({ size = 36, ...props }) => <svg {...props} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>;

export const Row = ({ k, v }) => (
  <div className="grid w-full max-w-full min-w-0 grid-cols-[minmax(4.5rem,0.7fr)_minmax(0,1fr)] gap-2 text-xs">
    <span className="min-w-0 text-slate-500">{k}</span>
    <span className="min-w-0 break-words text-right text-slate-800 [overflow-wrap:anywhere]">{v}</span>
  </div>
);
